<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo d-flex align-items-center justify-content-center">
        <b-img
          :src="logoUrl"
          alt="logo"
          width="80"
          class="mr-1"
        />
        <h2 class="brand-text mb-0 brandLogo" >
          CORSYMO
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Reset Password V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Reset Password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Reset Password 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Your new password must be different from previously used passwords.
          </b-card-text>

          <!-- form -->
          <validation-observer ref="resetPasswordForm">
            <b-form
              class="auth-reset-password-form mt-2"
              @submit.prevent="submit"
            >
              <!-- password -->
              <b-form-group
                label="New Password"
                label-for="reset-password-new"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="Password"
                  rules="required|password"
                  :immediate="false"
                  :bails="false"
                >
                  <div class="password-input-wrapper">
                    <b-form-input
                      id="reset-password-new"
                      v-model="password"
                      :type="passwordFieldType"
                      class="form-control-merge password-input"
                      :class="formSubmitted && errors.length > 0 ? 'is-invalid':null"
                      name="reset-password-new"
                      placeholder="············"
                    />
                    <feather-icon
                      class="cursor-pointer password-toggle-icon"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </div>
                  <div v-if="formSubmitted && errors.length > 0" class="error-message-wrapper">
                    <feather-icon icon="AlertCircleIcon" class="error-icon" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </validation-provider>
              </b-form-group>

              <!-- confirm password -->
              <b-form-group
                label-for="reset-password-confirm"
                label="Confirm Password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  rules="required|confirmed:Password"
                  :immediate="false"
                  :bails="false"
                >
                  <div class="password-input-wrapper">
                    <b-form-input
                      id="reset-password-confirm"
                      v-model="cPassword"
                      :type="passwordFieldType"
                      class="form-control-merge password-input"
                      :class="formSubmitted && errors.length > 0 ? 'is-invalid':null"
                      name="reset-password-confirm"
                      placeholder="············"
                    />
                    <feather-icon
                      class="cursor-pointer password-toggle-icon"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </div>
                  <div v-if="formSubmitted && errors.length > 0" class="error-message-wrapper">
                    <feather-icon icon="AlertCircleIcon" class="error-icon" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </validation-provider>
              </b-form-group>

              <!-- submit button -->
              <b-button
                block
                type="submit"
                variant="primary"
              >
                Set New Password
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'login'}">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Reset password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BCardTitle,
  BCardText,
  BForm,
  BFormGroup,
  BLink,
  BFormInput,
  BButton,
  BImg,
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import * as AuthServices from '@/apiServices/AuthServices'

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BImg,
    BLink,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      cPassword: '',
      password: '',
      formSubmitted: false,
      // validation
      required,
      sideImg: require('@/assets/images/pages/reset-password-v2.svg'),
      logo: require("@/assets/images/logo/corsymo_logo.png"),
      resetToken: null,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/reset-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    logoUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.logo = require("@/assets/images/logo/corsymo_logo_white.png");
        return this.logo;
      }
      return this.logo;
    },
  },
  created() {
    this.resetToken = this.$route.query.resetToken;
  },
  methods: {
    submit() {
      this.formSubmitted = true
      this.$refs.resetPasswordForm.validate().then(async success => {
        if (success) {
            try {
                const response = await AuthServices.resetPassword({
                    resetToken: this.resetToken,
                    password: this.password,
                });

                if (response.data.status) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {  
                      title: 'Success',
                      text: 'Your password has been reset successfully. Please log in.',
                      icon: 'CheckIcon',
                      variant: 'success',
                    },
                  });
                  this.$router.push({ name: 'login' });
                } else {
                     this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Error',
                            text: response.data.message || 'Failed to reset password.',
                            icon: 'XIcon',
                            variant: 'danger',
                        },
                    });
                }
            } catch (error) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error',
                        text: 'An error occurred. Please try again.',
                        icon: 'XIcon',
                        variant: 'danger',
                    },
                });
            }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.brandLogo {
  color: #1f307a;
}

.password-input-wrapper {
  position: relative;
  width: 100%;

  .password-input {
    padding-right: 45px;
    
    &.is-invalid {
      border-color: #ea5455;
      padding-right: 45px;
      
      &:focus {
        border-color: #ea5455;
        box-shadow: 0 0 0 0.2rem rgba(234, 84, 85, 0.25);
      }
    }
    
    // Hide Bootstrap Vue's default validation icons and background images
    &.is-invalid::after,
    &.is-valid::after {
      display: none !important;
    }
    
    &.is-invalid,
    &.is-valid {
      background-image: none !important;
      
      &:focus {
        background-image: none !important;
      }
    }
  }

  .password-toggle-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #6e6b7b;
    z-index: 10;
    transition: color 0.2s ease;

    &:hover {
      color: #5e50ee;
    }
  }
}

.error-message-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;

  .error-icon {
    width: 16px;
    height: 16px;
    color: #ea5455;
    flex-shrink: 0;
  }

  .text-danger {
    color: #ea5455;
    font-size: 0.875rem;
  }
}
</style>
